import { render, staticRenderFns } from "./curso-progreso.vue?vue&type=template&id=2ae25e88&scoped=true&"
import script from "./curso-progreso.vue?vue&type=script&lang=ts&"
export * from "./curso-progreso.vue?vue&type=script&lang=ts&"
import style0 from "./curso-progreso.vue?vue&type=style&index=0&id=2ae25e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae25e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
